var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ta-link-to-login",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onLogin($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }